<template>
    <div class="contentTopheader">
        <div class="minheader">
            <img src="/static/home/centerHeader.png" alt="" srcset="">
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {

        }
    }
}
</script>

<style lang="scss">
    .contentTopheader{
        width: 100vw;
        display: inline-flex;
        justify-content: center;
        height: 80px;
        align-items: center;
        background-color: #fff;
        .minheader{
            text-align: left;
            width: 100%;
            max-width: 1200px;
            img{
                width: 191px;
                height: 51px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/template/centerHeader.vue